var presets = [{
    title: "Ford",
    isGroup: !0,
    sizes: [{
        id: 1,
        title: "Focus RS",
        sizeUS: 13.9,
        sizeMetric: 52.62
    }, {
        id: 2,
        title: "Focus ST",
        sizeUS: 12.4,
        sizeMetric: 46.94
    }, {
        id: 3,
        title: "Fiesta ST",
        sizeUS: 12.4,
        sizeMetric: 46.94
    }, {
        id: 4,
        title: "Explorer ST",
        sizeUS: 20.2,
        sizeMetric: 76.5
    }, {
        id: 5,
        title: "Ecoboost Mustang",
        sizeUS: 15.5,
        sizeMetric: 58.67
    }]
}, {
    title: "Subaru",
    isGroup: !0,
    sizes: [{
        id: 6,
        title: "WRX/STI",
        sizeUS: 15.9,
        sizeMetric: 60
    }]
}];


$(document).ready(function() {
    $("#targetMix").keypress(StopDecimal);
    $("#fillLevel").keypress(StopDecimal);
    $("#mix").keypress(StopDecimal);
    $("#targetMix").keyup(MaxValue);
    $("#fillLevel").keyup(MaxValue);
    $("#mix").keyup(MaxValue);

    $("#targetMix").keyup(CheckCalculatable);
    $("#targetMix").keyup(function() {
    _cookie.targetMix = $("#targetMix").val();
    document.cookie = JSON.stringify(_cookie);
    });

    $("#pumpEthanolContent").keyup(function() {
    _cookie.pumpEthanolContent = $("#pumpEthanolContent").val();
    document.cookie = JSON.stringify(_cookie);
    });
    $("#pumpEthanolContent").keyup(CheckCalculatable);
    $("#e85EthanolContent").keyup(function() {
    _cookie.e85EthanolContent = $("#e85EthanolContent").val();
    document.cookie = JSON.stringify(_cookie);
    });
    $("#e85EthanolContent").keyup(CheckCalculatable);

    $("#fillLevel").keyup(CheckCalculatable);
    $("#mix").keyup(CheckCalculatable);

    $("#gallons").click(SelectGallons);
    $("#liters").click(SelectLiters);

    $("#form").submit(Calculate);

    $("#tankSizePreset").on('change', function () {
    _cookie.isCustom = false;
    RefreshTankSize();
    });
    $("#tankSize").keyup(InvalidatePreset);

    try {
    _cookie = JSON.parse(document.cookie);
    } catch(e) { }
    RebuildPresets(GetPreset(_cookie.id));
    RefreshTankSize();
    _cookie.isMetric ? SelectLiters() : SelectGallons();
    if (_cookie.isCustom) {
    $("#tankSize").val(_cookie.customValue);
    }
    $("#targetMix").val(_cookie.targetMix);
    $("#pumpEthanolContent").val(_cookie.pumpEthanolContent);
    $("#e85EthanolContent").val(_cookie.e85EthanolContent);
});

function InvalidatePreset() {
    var preset = GetPreset(_cookie.id);
    var val = $("#tankSizePreset").val();
    if ((_cookie.isMetric && val != preset.sizeMetric) || (!_cookie.isMetric && val != preset.sizeUS)) {
    $("#tankSizePreset").val(0);
    _cookie.id = 0;
    _cookie.customValue = $("#tankSize").val();
    _cookie.isCustom = true;
    document.cookie = JSON.stringify(_cookie);
    }
}

function RebuildPresets(selectedPreset) {
    var select = $("#tankSizePreset");
    select.empty();

    select.append($('<option>', {
    value: 0,
    text: "-- Select Car --"
    }))

    for (var i = 0; i < presets.length; i++) {
    var p = presets[i];
    if (p.isGroup) {
        var group = $('<optgroup>', {
            label: p.title
        });
        select.append(group);
        for (var ii = 0; ii < p.sizes.length; ii++) {
        var c = p.sizes[ii];
        group.append($('<option>', {
            value: c.id,
            text: c.title,
        }));
        }
    } else {
        select.append($('<option>', {
            value: p.id,
            text: p.title
        }));
    }
    }

    select.val(selectedPreset.id);
}

function GetPreset(id) {
    for (var i = 0; i < presets.length; i++) {
    if (presets[i].isGroup) {
        for (var ii = 0; ii < presets[i].sizes.length; ii++) {
        if (presets[i].sizes[ii].id == id)
            return presets[i].sizes[ii];
        }
    }

    if (presets[i].id == id)
        return presets[i];
    }
    return {id:0};
}

var _hasCalculated = false;
var _cookie = {
    id: 0,
    isCustom: false,
    customValue: 0,
    isMetric: false,
    targetMix: 30,
    pumpEthanolContent: 10,
    e85EthanolContent: 85
}

function RefreshTankSize() {
    var preset = GetPreset($("#tankSizePreset").val());
    $("#tankSize").val(_cookie.isMetric ? preset.sizeMetric : preset.sizeUS);
    _cookie.id = preset.id;
    document.cookie = JSON.stringify(_cookie);
}

function Calculate() {
    var targetMix = parseFloat($("#targetMix").val(),10);
    var currentFillLevel = parseFloat($("#fillLevel").val(),10);
    var currentMix = parseFloat($("#mix").val(),10);

    var result = CalculateNewMixture(currentFillLevel, targetMix, currentMix, 0.001, $("#tankSize").val(), _cookie.e85EthanolContent, _cookie.pumpEthanolContent);

    $("#e85").html(result.E85Added.toFixed(2) + (_cookie.isMetric ? "L" : "g"));
    $("#pump").html(result.PumpAdded.toFixed(2) + (_cookie.isMetric ? "L" : "g"));
    $("#mixResult").html(result.ResultingMix.toFixed(1) + "% Ethanol (E" + result.ResultingMix.toFixed(0) + ")");
    $(".results").show();
    _hasCalculated = true;
    return false;
}

function SelectGallons() {
    _cookie.isMetric = false;
    document.cookie = JSON.stringify(_cookie);
    $("#liters").removeClass("uk-active");
    $("#gallons").addClass("uk-active");
    RefreshTankSize();
    if (_hasCalculated)
    Calculate();
}
function SelectLiters() {
    _cookie.isMetric = true;
    document.cookie = JSON.stringify(_cookie);
    $("#gallons").removeClass("uk-active");
    $("#liters").addClass("uk-active");
    RefreshTankSize();
    if (_hasCalculated)
    Calculate();
}

function StopDecimal(e) { if (e.key == ".") e.preventDefault(); }
function MaxValue(e) { if (e.target.value > 100) e.target.value = 100; }
function CheckCalculatable(e) {
    var targetMix = parseFloat($("#targetMix").val(),10);
    var currentFillLevel = parseFloat($("#fillLevel").val(),10);
    var currentMix = parseFloat($("#mix").val(),10);

    if (isNaN(targetMix) || isNaN(currentFillLevel) || isNaN(currentMix))
    $(".results").hide();
    else {
    Calculate();
    $(".results").show();
    }
}

function CalculateNewMixture(currentFillLevel, targetMix, currentMix, resolution, tankSize, e85EthanolContent, pumpEthanolContent) {
    var currentGallons = tankSize * (currentFillLevel/100);
    var e85Added = 0;
    var pumpAdded = 0;

    while(tankSize-currentGallons > 0) {
    var newEthanolContent = currentMix < targetMix ? e85EthanolContent : pumpEthanolContent;
    var addingE85 = currentMix < targetMix;
    var newMix = ((currentGallons*currentMix)+(resolution*newEthanolContent))/(currentGallons+resolution);

    addingE85 ? e85Added += resolution : pumpAdded += resolution;
    currentGallons += resolution;
    currentMix = ((currentGallons*currentMix)+(resolution*newEthanolContent))/(currentGallons+resolution);
    }

    return {
    E85Added: e85Added,
    PumpAdded: pumpAdded,
    ResultingMix: currentMix
    }
}